import { Custom } from 'ui/icons/events';

import { SystemEventName, EventName, EventLabel, EVENT_LABELS } from '../domain';
import { AGGREGATE_EVENT_LABELS, EVENT_ICONS } from './constants';

export const isSystemEvent = (eventName?: EventName): eventName is SystemEventName =>
  Boolean(EVENT_LABELS[eventName as SystemEventName]);

export const convertToLabel = (event: EventLabel) =>
  event.eventType === 'System' || event.eventType === 'Custom'
    ? (event.eventName as EventName)
    : event.eventType;

export const getAggregateEventLabel = (eventName: EventName) =>
  isSystemEvent(eventName) ? AGGREGATE_EVENT_LABELS[eventName] : eventName;

export const getEventLabel = (event: EventLabel) => {
  const eventLabel = convertToLabel(event);
  return isSystemEvent(eventLabel) ? EVENT_LABELS[eventLabel] : event.eventName || event.eventType;
};

export const getEventIcon = (eventName: EventName) =>
  isSystemEvent(eventName) ? EVENT_ICONS[eventName] : Custom;
